import { _ } from "../../../../core/polyglot/polyglot.js";
import { formatAsDateAndTime } from "../../../../core/helpers/date-formatting-util.js";
import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * `PeriodReportEventLogWidget` displays the log of events.
 *
 * @param {periodReportEvent[]} [spec.events] - period report events to display
 */
export default class PeriodReportEventLogWidget extends Widget {
	constructor({ events }) {
		super(...arguments);
		this._events = events;
	}

	renderContentOn(html) {
		html.div(
			{ klass: "audit-items" },
			this._events.map(this._auditItemRenderer.bind(this)),
		);
	}

	_auditItemRenderer(event) {
		const author = event.getAuthor();
		const authorName = author.getName();
		const authorAvatarSource =
			author.getAvatarData() || "/Client/img/avatar-user-grey-lg.png";
		const timestamp = event.getTimestamp();
		return (html) =>
			html.div(
				{ klass: "audit-item" },
				html.div(
					{ klass: "avatar" },
					html.img({ src: authorAvatarSource }),
				),
				html.div(
					{ klass: "text" },
					authorName || _("Author name not available"),
					html.br(),
					this._eventTypeRenderer(event),
					html.br(),
					(timestamp && formatAsDateAndTime(timestamp)) ||
						_("Timestamp info not available"),
				),
			);
	}

	_eventTypeRenderer(event) {
		return event.getLabel();
	}
}
